export default __webpack_public_path__ + "static/transactionalmessage-7a7430f1d6a02e760fbdae0703a9dba2.png";